import { usePostMutation } from "@/api/swr/useMutation";
import { assignCompanySchema } from "@/schema/console/assessors/AssignCompany";
import { z } from "zod";

type Config = Parameters<
  typeof usePostMutation<typeof assignCompanySchema, z.ZodNull>
>[3];

export const useAssignCompany = (id: number, config?: Config) => {
  return usePostMutation(
    assignCompanySchema,
    z.null(),
    `/console/admin_users/${id}/assign_company`,
    config,
  );
};
